export const ANALYTICS_EVENT_SEGMENTS = {
  VUP: '[Varejo ou Uniclass ou Person]',
};
